export const BRAND_NAME = "妙柔到家";
export const BRAND_SUBTITLE = "专业线上推拿按摩服务平台";
export const CUSTOMER_PLATFORM_NAME = `${BRAND_NAME} · 到家服务用户端`;

export const brand = {
  name: BRAND_NAME,
  subtitle: BRAND_SUBTITLE,
  customerPlatformName: CUSTOMER_PLATFORM_NAME,
};
